























































import { Component, Vue } from "vue-property-decorator";

import { passwordApi } from "../../plugins/auth-plugin/services/password.api";
import appSnackbarService from "../../services/appSnackbar.service";

@Component({})
export default class ChangeUserPassword extends Vue {
  currentPassword = "";
  password1 = "";
  password2 = "";
  userName = "";
  errorMessage = "";
  valid = false;
  loading = false;

  show1 = false;
  show2 = false;

  passwordRule(v: string) {
    // if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z\d\W]{4,}$/.test(v)) {
    if (!/^(?=.*\d)[a-zA-Z\d\W]{4,}$/.test(v)) {
      return this.$t("CHANGE_PASSWORD_RULE");
    }
    return true;
  }

  changePassword() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      passwordApi
        .resetUserPassword(this.currentPassword, this.password2)
        .then(() => {
          this.$router.replace("/login");
          appSnackbarService.success(
            this.$t("CHANGE_PASSWORD_SUCCESS") as string
          );
        })
        .catch(error => {
          this.errorMessage = this.$t("CHANGE_PASSWORD_ERROR") as string;
          this.loading = false;
        });
    }
  }
}
